export default __webpack_public_path__ + "static/unruly-7c977ca44991a289e052d684b5052a9e.svg";